export function TriggeredActions() {
	return <div>
		Triggered Actions
	</div>
}